import React from 'react';
const CONSTRUCTION_PROOF = 'https://cdn.magicpatterns.com/uploads/7a6LHA6xCFM7aKNSPwHxhf/image.png';
export function WorkInProgress() {
  return <section className="border-b border-[#D4AF37]/12 bg-[#08070A]" data-id="element-1484" data-mp="1hs39iwo80nde">
      <div className="mx-auto w-full max-w-7xl px-5 py-16 sm:px-8 lg:py-20" data-id="element-1485" data-mp="1ctrzolxxecv6">
        <figure data-id="element-1486" data-mp="18u15075a3cld">
          <img src={CONSTRUCTION_PROOF} alt="Live Sikh Kingdoms projection and environment tests inside Illuminarium Toronto" className="w-full border border-[#D4AF37]/25 object-contain" data-id="element-1487" data-mp="18sg9ofb53pmg" />
        </figure>
      </div>
    </section>;
}